export default __webpack_public_path__ + "static/media/EllipseProfileImg.2126a8b8.png";